<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-input v-model="keyword" placeholder="请输入手机号" class="handle-input mr10"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down fr"
          @click="exportuserlist"
        >导出用户信息</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        v-loading="loading"
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index+1+page_index}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="created_at" label="加入时间" align="center"></el-table-column>
        <el-table-column label="头像" align="center" width="200">
          <template slot-scope="scope">
            <el-image
              class="table-td-thumb"
              v-if="scope.row.avatar"
              :src="scope.row.avatar"
              :preview-src-list="[scope.row.avatar]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
<!--        <el-table-column prop="nickname" label="绑定状态" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <p v-if="scope.row.wx_id">微信绑定</p>-->
<!--            <p v-if="scope.row.qq_id">QQ绑定</p>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleAddressLook(scope.row)">地址管理</el-button>
            <el-button type="text" @click="handleDiagnosisLook(scope.row)">问诊记录</el-button>
            <el-button type="text" @click="handleArchivesLook(scope.row)">健康档案</el-button>
            <!-- <el-button type="text" @click="handleDelete(scope.row)">拉黑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="totalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="currentPage"
          :page-size="page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 问诊记录 -->
    <el-dialog :visible.sync="diagnosisLookVisible" width="80%" :close-on-click-modal="false">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-delete"
          class="handle-del mr10"
          @click="delDiagnosisAllSelection"
        >批量删除</el-button>
        <el-select
          v-model="diagnosis_type"
          style="width:200px"
          class="handle-select mr10"
          @change="handleDiagnosisSelect"
        >
          <el-option
            v-for="(child, index) in diagnosis_types"
            :key="index"
            :label="child.label"
            :value="child.value"
          ></el-option>
        </el-select>
        <el-input v-model="diagnosis_keyword" class="handle-input mr10"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleDiagnosisSearch">搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down fr"
          @click="exportdiagnosislist"
        >导出用户问诊记录</el-button>
      </div>
      <el-table
        :data="diagnosisTableData"
        border
        class="table"
        ref="windowMultipleTable"
        header-cell-class-name="table-header"
        v-loading="window_loading"
        @selection-change="handleDiagnosisSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index+1+window_page_index}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="title" label="职称" align="center"></el-table-column>
        <el-table-column prop="department" label="科室" align="center"></el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">{{getWindowType(scope.row.type)}}</template>
        </el-table-column>
        <el-table-column prop="area" label="地区" align="center"></el-table-column>
        <el-table-column label="日期" align="center">
          <template slot-scope="scope">{{formatDate(scope.row.created_at)}}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDiagnosisDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="windowTotalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="windowCurrentPage"
          :page-size="window_page_size"
          :total="windowPageTotal"
          @current-change="handleDiagnosisPageChange"
        ></el-pagination>
      </div>
    </el-dialog>

    <!-- 地址管理 -->
    <el-dialog :visible.sync="addressLookVisible" width="80%" :close-on-click-modal="false">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-delete"
          class="handle-del mr10"
          @click="delAddressAllSelection"
        >批量删除</el-button>
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add"
          @click="addAddressEdit(true, '')"
        >新增</el-button>
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down fr"
          @click="exportaddresslist"
        >导出用户地址</el-button>
      </div>
      <el-table
        :data="addressTableData"
        border
        class="table"
        ref="windowMultipleTable"
        header-cell-class-name="table-header"
        v-loading="window_loading"
        @selection-change="handleAddressSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index+1+window_page_index}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="姓名" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column label="地区" align="center">
          <template slot-scope="scope">{{getAddressArea(scope.row.area)}}</template>
        </el-table-column>
        <el-table-column prop="address" label="详细地址" align="center"></el-table-column>
        <el-table-column prop="tag_name" label="标签" align="center"></el-table-column>
        <el-table-column label="是否为默认地址" align="center">
          <template slot-scope="scope">
           <div  @click="defaultAddress(scope.row)" v-if="scope.row.is_default == 2"> <el-tag type="success" >是</el-tag></div>
            <div  @click="defaultAddress(scope.row)" v-else> <el-tag type="danger" >否</el-tag></div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="addAddressEdit(false, scope.row)">修改</el-button>
            <el-button type="text" icon="el-icon-delete" @click="handleAddressDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="windowTotalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="windowCurrentPage"
          :page-size="window_page_size"
          :total="windowPageTotal"
          @current-change="handleAddressPageChange"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 地址编辑弹出框 -->
    <el-dialog :visible.sync="addressEditVisible" width="50%" :close-on-click-modal="false">
      <el-form ref="addressForm" :model="address_form" :rules="address_rules" label-width="120px">
        <el-form-item label="姓名：" prop="nickname">
          <el-input v-model="address_form.nickname" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号："
          prop="phone"
          :rules="[{ required: true, validator: checkPhone, trigger: 'blur' }]"
        >
          <el-input v-model="address_form.phone" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="省份：" prop="province">
          <el-select
            v-model="address_form.province"
            placeholder="请选择"
            class="handle-select"
            style="width:160px"
            @change="handleProvinceSelect"
          >
            <el-option
              v-for="(child, index) in provinces"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市(区)：" prop="city" v-show="city_show">
          <el-select
            v-model="address_form.city"
            placeholder="请选择"
            class="handle-select"
            style="width:160px"
            @change="handleCitySelect"
          >
            <el-option
              v-for="(child, index) in citys"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区(县)：" prop="street">
          <el-select
            v-model="address_form.street"
            placeholder="请选择"
            class="handle-select"
            style="width:160px"
          >
            <el-option
              v-for="(child, index) in streets"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址：" prop="address">
          <el-input v-model="address_form.address" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="标签：" prop="tag_name">
          <el-select v-model="address_form.tag_name" class="handle-select" style="width:160px">
            <el-option
              v-for="(child, index) in address_tags"
              :key="index"
              :label="child.value"
              :value="child.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveAddresssEdit('addressForm')">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 健康档案管理 -->
    <el-dialog :visible.sync="archivesLookVisible" width="80%" :close-on-click-modal="false">
      <div class="handle-box">
        <el-button
          type="primary"
          icon="el-icon-delete"
          class="handle-del mr10"
          @click="delArchivesAllSelection"
        >批量删除</el-button>
        <el-button
          type="primary"
          icon="el-icon-lx-add"
          class="handle-add mr10"
          @click="addArchivesEdit(true, '')"
        >新增</el-button>
        <el-input v-model="archives_keywords" placeholder="请输入姓名" class="handle-input mr10"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="handleArchivesSearch">搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-lx-down"
          class="handle-down fr"
          @click="exportarchiveslist"
        >导出用户健康档案</el-button>
      </div>
      <el-table
        :data="archivesTableData"
        border
        class="table"
        ref="windowMultipleTable"
        header-cell-class-name="table-header"
        v-loading="window_loading"
        @selection-change="handleArchivesSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index+1+window_page_index}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
        <el-table-column label="性别" align="center">
          <template slot-scope="scope">{{getSexType(scope.row.sex)}}</template>
        </el-table-column>
        <el-table-column prop="age" label="年龄(岁)" align="center"></el-table-column>
        <el-table-column prop="height" label="身高(cm)" align="center"></el-table-column>
        <el-table-column prop="weight" label="体重(kg)" align="center"></el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="lookArchivesDetail(scope.row)">详情</el-button>
            <el-button type="text" icon="el-icon-edit" @click="addArchivesEdit(false, scope.row)">修改</el-button>
            <el-button type="text" icon="el-icon-delete" @click="handleArchivesDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" v-if="windowTotalPages > 1">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="windowCurrentPage"
          :page-size="window_page_size"
          :total="windowPageTotal"
          @current-change="handleAddressPageChange"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- 档案编辑弹出框 -->
    <el-dialog :visible.sync="archivesEditVisible" width="50%" :close-on-click-modal="false">
      <el-form
        ref="archivesForm"
        :model="archives_form"
        :rules="archives_rules"
        label-width="120px"
      >
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="archives_form.name" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-select v-model="archives_form.sex" class="handle-select">
            <el-option
              v-for="(child, index) in sexTypes"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出生日期：" prop="birthday">
          <el-date-picker
            v-model="archives_form.birthday"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="关系：" prop="relationship_id">
          <el-select v-model="archives_form.relationship_id" class="handle-select">
            <el-option
              v-for="(child, index) in relationships"
              :key="index"
              :label="child.title"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="手机号："
          prop="phone"
          :rules="[{ required: true, validator: checkPhone, trigger: 'change' }]"
        >
          <el-input v-model="archives_form.phone" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="身高(cm)：" prop="height">
          <el-input v-model="archives_form.height" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="体重(kg)：" prop="weight">
          <el-input v-model="archives_form.weight" @input="onInput()"></el-input>
        </el-form-item>
        <el-form-item label="现病史：" prop="anamnesis">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            v-model="archives_form.anamnesis"
            @input="onInput()"
          ></el-input>
        </el-form-item>
        <el-form-item label="既往史：" prop="allergic_history">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            v-model="archives_form.allergic_history"
            @input="onInput()"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveArchivesEdit('archivesForm')">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 档案详情弹出框 -->
    <el-dialog :visible.sync="archivesDetailVisible" width="50%" :close-on-click-modal="false">
      <el-form label-width="120px">
        <el-form-item label="姓名：" prop="name">
          <span class="fc">{{archives_detail.name}}</span>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <span class="fc">{{archives_detail.sex}}</span>
        </el-form-item>
        <el-form-item label="出生日期：" prop="birthday">
          <span class="fc">{{archives_detail.birthday}}</span>
        </el-form-item>
        <el-form-item label="关系：">
          <span class="fc">{{archives_detail.relationship_title}}</span>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <span class="fc">{{archives_detail.phone}}</span>
        </el-form-item>
        <el-form-item label="身高(cm)：">
          <span class="fc">{{archives_detail.height}}</span>
        </el-form-item>
        <el-form-item label="体重(kg)：">
          <span class="fc">{{archives_detail.weight}}</span>
        </el-form-item>
        <el-form-item label="现病史：">
          <span class="fc">{{archives_detail.anamnesis}}</span>
        </el-form-item>
        <el-form-item label="既往史：">
          <span class="fc">{{archives_detail.allergic_history}}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="closeArchivesDetail">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import http from "../../../api/gaeaApiConfig";
import http2 from "../../../api/iapetusApiConfig";
import http3 from "../../../api/hermerApiConfig";
import VUE_APP_API_GAEA_URL from "../../../api/getapi/gaea";
import VUE_APP_API_IAPETUS_URL from "../../../api/getapi/iapetus";
import $ from "jquery";
export default {
  name: "Userslist",
  data() {
    return {
      sexTypes: [
        { name: "女", id: 0 },
        { name: "男", id: 1 },
      ],
      diagnosis_types: [
        { label: "全部", value: "" },
        { label: "未支付", value: 0 },
        { label: "待接诊", value: 1 },
        { label: "问诊中", value: 2 },
        { label: "已结束", value: 3 },
        { label: "付款后未接诊退款", value: 4 },
      ],
      address_tags: [{ value: "家" }, { value: "公司" }, { value: "学校" }],
      diagnosis_type: "",
      //   用户列表
      excelData: [],
      excel_current: 1,
      excel_totals: 1,
      //    健康档案
      archivesData: [],
      archives_current: 1,
      archives_totals: 1,
      //   地址导出
      addressData: [],
      address_current: 1,
      address_totals: 1,
      tableData: [],
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 0,
      keyword: "",
      loading: false,
      diagnosisTableData: [],
      addressTableData: [],
      windowCurrentPage: 1,
      windowTotalPages: 1,
      window_page_size: 10,
      windowPageTotal: 10,
      window_page_index: 0,
      diagnosis_keyword: "",
      window_loading: false,
      is_add: false,
      city_show: true,
      select_user_id: 1,
      diagnosismultipleSelection: [],
      addressmultipleSelection: [],
      delList: [],
      provinces: [],
      citys: [],
      streets: [],
      diagnosisLookVisible: false,
      addressLookVisible: false,
      addressEditVisible: false,
      address_form: {},
      address_rules: {
        nickname: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        province: [{ required: true, message: "请选择省份", trigger: "blur" }],
        city: [{ required: true, message: "请选择市(区)", trigger: "blur" }],
        street: [{ required: true, message: "请选择区(县)", trigger: "blur" }],
        address: [
          { required: true, message: "请填写详细地址", trigger: "blur" },
        ],
      },
      archives_form: {},
      archives_keywords: "",
      archivesTableData: [],
      archivesLookVisible: false,
      archivesEditVisible: false,
      archivesmultipleSelection: [],
      relationships: [],
      archives_rules: {
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        relationship_id: [
          { required: true, message: "请选择关系", trigger: "blur" },
        ],
        weight: [{ required: true, message: "请填写体重", trigger: "blur" }],
        height: [{ required: true, message: "请填写身高", trigger: "blur" }],
      },
      archivesDetailVisible: false,
      archives_detail: {},
    };
  },
  created() {
    let that = this;
    this.getData();
    http3.get("/areas/0").then(function (res) {
      that.provinces = res.data.data;
    });
    http2.get("/relationships").then(function (res) {
      that.relationships = res.data.data;
    });
  },
  methods: {
    getRelationshipTitle(id) {
      let item = _.filter(this.relationships, function (selector) {
        return selector.id === id;
      })[0];
      if (item) {
        return item["title"];
      } else {
        return "";
      }
    },
    checkPhone(rule, value, callback) {
      var re = new RegExp(/^(1)+\d{10}$/);
      console.log(value);
      if (value.length == 0) {
        callback(new Error("手机号不能为空"));
      } else if (!re.test(value)) {
        callback(new Error("请填写正确的手机号1"));
      } else {
        callback();
      }
    },
    getSexType(id) {
      console.log(id,'xingbie')
      if (this.sexTypes[id]) {
        return this.sexTypes[id]["name"];
      } else {
        return "未知";
      }
    },
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    getWindowType(id) {
      let item = _.filter(this.diagnosis_types, function (selector) {
        return selector.value === id;
      })[0];
      if (item) {
        return item["label"];
      } else {
        return "";
      }
    },
    getAddressArea(arr) {
      let area = "";
      arr = JSON.parse(arr);
      for (let i = 0; i < arr.length; i++) {
        area += arr[i]["name"];
      }
      area = area.replace("市辖区", "");
      return area;
    },
    defaultAddress(row){
      console.log(row)
    },
    onInput() {
      this.$forceUpdate();
    },
    getData() {
      let that = this;
      that.loading = true;
      let params = {
        page: that.currentPage,
        page_size: that.page_size,
      };
      params["phone"] = that.keyword;
      http.get("/admin/users", { params: params }).then(function (res) {
        that.page_index = (that.currentPage - 1) * that.page_size;
        that.tableData = res.data.data.users;
        that.currentPage = res.data.data.current_page;
        that.totalPages = res.data.data.total_pages;
        that.pageTotal = that.totalPages * that.page_size;
        that.loading = false;
      });
    },
    // 用户列表导出
    exportuserlist() {
      let that = this;
      let params = {
        page: that.excel_current,
        page_size: 100,
      };
      params["phone"] = that.keyword;
      //params["studio_id"] = that.studio_id;
      http.get("/admin/users", { params: params }).then(function (res) {
        // console.log(res);
        that.excelData = res.data.data.users;
        that.excel_current = res.data.data.page;
        that.excel_totals = res.data.data.total_pages;
        // console.log(res.data.data.users)
        if (that.excel_totals == 1) {
          that.exportuser(that.excelData);
        } else {
          that.exportuseralllist();
        }
      });
    },
    // 导出医生列表 请求剩余页
    exportuseralllist() {
      let that = this;
      let apiURL = "";
      that.excel_current = 2;
      if (process.env.NODE_ENV === "development") {
        // alert("开发环境");
        apiURL = "http://proxy.jiankanghao.net:50205/api/v1";
      } else {
        // alert("生产环境");
        apiURL = VUE_APP_API_GAEA_URL;
      }
      apiURL = apiURL + "/admin/users";
      for (let i = 2; i <= this.excel_totals; i++) {
        // console.log(i);
        let params = {
          page: that.excel_current,
          page_size: 100,
        };
        params["phone"] = that.keyword;
        $.ajax({
          type: "GET",
          async: false, // fasle表示同步请求，true表示异步请求
          contentType: "application/json;charset=UTF-8",
          url: apiURL,
          data: params,
          success: function (data) {
            // console.log(data);
            if (data.status_code == 200) {
              that.excelData = that.excelData.concat(data.data.users);
              that.excel_current += 1;
              that.excel_totals = data.data.total_pages;
              // console.log(that.excelData)
            }
          },
          error: function (e) {
            console.log(e.status);
            console.log(e.responseText);
          },
        });
      }
      //   console.log(that.excelData);
      this.exportuser(that.excelData);
    },
    // 导出医生列表 导出方法
    exportuser(res) {
        console.log(res);
      let that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../utils/Export2Excel.js");
        const tHeader = ["昵称", "头像", "手机号"];
        const filterVal = ["nickname", "avatar", "phone"];
        const list = res;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "用户信息列表");
        that.excelData = [];
        that.excel_current = 1;
        that.excel_totals = 1;
      });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getDiagnosisData() {
      let that = this;
      that.window_loading = true;
      let params = {
        page: that.windowCurrentPage,
        page_size: that.window_page_size,
      };
      if (that.diagnosis_keyword) {
        params["keywords"] = that.diagnosis_keyword;
      }
      if (that.diagnosis_type) {
        params["type"] = that.diagnosis_type;
      }
      http2
        .get("/admin/users/" + that.select_user_id + "/diagnosis", {
          params: params,
        })
        .then(function (res) {
          that.window_page_index =
            (that.windowCurrentPage - 1) * that.window_page_size;
          that.diagnosisTableData = res.data.data.items;
          that.windowCurrentPage = res.data.data.current_page;
          that.windowTotalPages = res.data.data.total_pages;
          that.windowPageTotal = that.windowTotalPages * that.window_page_size;
          that.window_loading = false;
        });
    },
    // 导出问诊记录 请求第一页
    exportdiagnosislist() {
      let that = this;
      let params = {
        page: that.diagnosis_current,
        page_size: 100,
      };
      if (that.keywords) {
        params["keywords"] = that.keywords;
      }
      //params["studio_id"] = that.studio_id;
      http2.get(`admin/users/`+that.select_user_id+`/diagnosis`, { params: params }).then(function (res) {
        // console.log(res);
        that.diagnosisData = res.data.data.items;
        that.diagnosis_current = res.data.data.page;
        that.diagnosis_totals = res.data.data.total_pages;
        if (that.diagnosis_totals == 1) {
            that.exportdiagnosis(that.diagnosisData);
        } else {
          that.exportdiagnosisalllist();
        }
      });
    },
    // 导出问诊记录 请求剩余页
    exportdiagnosisalllist() {
      let that = this
      let apiURL = "";
        that.diagnosis_current = 2
      if (process.env.NODE_ENV === "development") {
        // alert("开发环境");
        apiURL = "http://proxy.jiankanghao.net:50206/api/v1";
      } else {
        // alert("生产环境");
        apiURL = VUE_APP_API_IAPETUS_URL;
      }
      apiURL = apiURL+`admin/users/`+that.select_user_id+`/diagnosis`
      for (let i = 2; i <= this.diagnosis_totals; i++) {
        // console.log(i);
        let params = {
          page: that.diagnosis_current,
          page_size: 100,
        };
        if (that.keywords) {
          params["keywords"] = that.keywords;
        }
        $.ajax({
          type: "GET",
          async: false, // fasle表示同步请求，true表示异步请求
          contentType: "application/json;charset=UTF-8",
          url: apiURL,
          data: params,
          success: function (data) {
            // console.log(data);
            if(data.status_code == 200){
                that.diagnosisData = that.diagnosisData.concat(data.data.items)
                that.diagnosis_current += 1;
                that.diagnosis_totals = data.data.total_pages;
                // console.log(that.diagnosisData)
            }
          },
          error: function (e) {
            console.log(e.status);
            console.log(e.responseText);
          },
        });
      }
      console.log(that.diagnosisData)
      this.exportdiagnosis(that.diagnosisData)
    },
    // 导出问诊记录 导出方法
    exportdiagnosis(res) {
      console.log(res);
      let that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../utils/Export2Excel.js");
        const tHeader = [
          "姓名",
          "职称",
          "科室",
          "类型",
          "地区",
          "日期"
        ];
        const filterVal = [
          "name",
          "title",
          "department",
          "type",
          "area",
          "created_at",
        ];
        const list = res;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "用户问诊记录列表");
        that.diagnosisData = []
        that.diagnosis_current = 1
        that.diagnosis_totals = 1
      });
    },
    getAddressData() {
      let that = this;
      that.window_loading = true;
      let params = {
        page: that.windowCurrentPage,
        page_size: that.window_page_size,
      };
      http
        .get("/admin/user/" + that.select_user_id + "/addresses", {
          params: params,
        })
        .then(function (res) {
          that.window_page_index =
            (that.windowCurrentPage - 1) * that.window_page_size;
          that.addressTableData = res.data.data.addresses;
          that.windowCurrentPage = res.data.data.current_page;
          that.windowTotalPages = res.data.data.total_pages;
          that.windowPageTotal = that.windowTotalPages * that.window_page_size;
          that.window_loading = false;
        });
    },// 导出地址列表 请求第一页
    exportaddresslist() {
      let that = this;

      let params = {
        page: that.address_current,
        page_size: 100,
      };
      if (that.keywords) {
        params["keywords"] = that.keywords;
      }
      //params["studio_id"] = that.studio_id;
      http.get(`admin/user/`+that.select_user_id+`/addresses`, { params: params }).then(function (res) {
        console.log(res,'address');
        that.addressData = res.data.data.addresses;
        that.address_current = res.data.data.page;
        that.address_totals = res.data.data.total_pages;
        if (that.address_totals == 1) {
            that.exportaddress(that.addressData);
        } else {
          that.exportaddressalllist();
        }
      });
    },
    // 导出地址列表 请求剩余页
    exportaddressalllist() {
      let that = this
      let apiURL = "";
        that.address_current = 2
      if (process.env.NODE_ENV === "development") {
        // alert("开发环境");
        apiURL = "http://proxy.jiankanghao.net:50206/api/v1";
      } else {
        // alert("生产环境");
        apiURL = VUE_APP_API_IAPETUS_URL;
      }
      apiURL = apiURL+'/admin/addresss'
      for (let i = 2; i <= this.address_totals; i++) {
        // console.log(i);
        let params = {
          page: that.address_current,
          page_size: 100,
        };
        if (that.keywords) {
          params["keywords"] = that.keywords;
        }
        $.ajax({
          type: "GET",
          async: false, // fasle表示同步请求，true表示异步请求
          contentType: "application/json;charset=UTF-8",
          url: apiURL,
          data: params,
          success: function (data) {
            // console.log(data);
            if(data.status_code == 200){
                that.addressData = that.addressData.concat(data.data.items)
                that.address_current += 1;
                that.address_totals = data.data.total_pages;
                // console.log(that.addressData)
            }
          },
          error: function (e) {
            console.log(e.status);
            console.log(e.responseText);
          },
        });
      }
      console.log(that.addressData)
      this.exportaddress(that.addressData)
    },
    // 导出地址列表 导出方法
    exportaddress(res) {
      console.log(res);
      let that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../utils/Export2Excel.js");
        const tHeader = [
          "昵称",
          "手机号",
          "地区",
          "详细地址",
          "标签",
          "是否为默认地址"
        ];
        const filterVal = [
          "nickname",
          "phone",
          "area",
          "address",
          "tag_name",
          "is_default"
        ];
        const list = res;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "用户地址信息列表");
        that.addressData = []
        that.address_current = 1
        that.address_totals = 1
      });
    },
    getArchivesData() {
      let that = this;
      that.window_loading = true;
      let params = {
        page: that.windowCurrentPage,
        page_size: that.window_page_size,
      };
      if (that.archives_keywords) {
        params["keywords"] = that.archives_keywords;
      }
      http2
        .get("/admin/users/" + that.select_user_id + "/archives", {
          params: params,
        })
        .then(function (res) {
          that.window_page_index =
            (that.windowCurrentPage - 1) * that.window_page_size;
          that.archivesTableData = res.data.data.items;
          that.windowCurrentPage = res.data.data.page;
          that.windowTotalPages = res.data.data.total_pages;
          that.windowPageTotal = that.windowTotalPages * that.window_page_size;
          that.window_loading = false;
        });
    },
    // 健康档案列表
    exportarchiveslist() {
      let that = this;
      let params = {
        page: that.archives_current,
        page_size: 100,
      };
      if (that.archives_keywords) {
        params["keywords"] = that.archives_keywords;
      }
      //params["studio_id"] = that.studio_id;
      http2
        .get("/admin/users/" + that.select_user_id + "/archives", {
          params: params,
        })
        .then(function (res) {
          // console.log(res);
          that.archivesData = res.data.data.items;
          that.archives_current = res.data.data.page;
          that.archives_totals = res.data.data.total_pages;
          // console.log(res.data.data.items)
          if (that.archives_totals == 1) {
            that.exportarchives(that.archivesData);
          } else {
            that.exportarchivesalllist();
          }
        });
    },
    // 导出健康档案列表 请求剩余页
    exportarchivesalllist() {
      let that = this;
      let apiURL = "";
      that.archives_current = 2;
      if (process.env.NODE_ENV === "development") {
        // alert("开发环境");
        apiURL = "http://proxy.jiankanghao.net:50206/api/v1";
      } else {
        // alert("生产环境");
        apiURL = VUE_APP_API_IAPETUS_URL;
      }
      apiURL = apiURL + "/admin/users/" + that.select_user_id + "/archives";
      for (let i = 2; i <= this.archives_totals; i++) {
        // console.log(i);
        let params = {
          page: that.archives_current,
          page_size: 100,
        };
        if (that.archives_keywords) {
          params["keywords"] = that.archives_keywords;
        }
        $.ajax({
          type: "GET",
          async: false, // fasle表示同步请求，true表示异步请求
          contentType: "application/json;charset=UTF-8",
          url: apiURL,
          data: params,
          success: function (data) {
            // console.log(data);
            if (data.status_code == 200) {
              that.archivesData = that.archivesData.concat(data.data.items);
              that.archives_current += 1;
              that.archives_totals = data.data.total_pages;
              // console.log(that.excelData)
            }
          },
          error: function (e) {
            console.log(e.status);
            console.log(e.responseText);
          },
        });
      }
      //   console.log(that.excelData);
      this.exportarchives(that.archivesData);
    },
    // 导出健康档案列表 导出方法
    exportarchives(res) {
      //   console.log(res);
      let that = this;
      require.ensure([], () => {
        const {
          export_json_to_excel,
        } = require("../../../utils/Export2Excel.js");
        const tHeader = ["姓名", "手机号", "性别", "年龄", "身高", "体重"];
        const filterVal = ["name", "phone", "sex", "age", "height", "weight"];
        const list = res;
        const data = that.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "用户健康档案信息列表");
        that.archivesData = [];
        that.archives_current = 1;
        that.archives_totals = 1;
      });
    },
    // 触发搜索按钮
    handleSearch() {
      this.currentPage = 1;
      this.getData();
    },
    // 删除操作
    handleDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要拉黑吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          let params = {
            user_id: row.id,
          };
          http.delete("/admin/users", { params: params }).then(function (res) {
            // console.log(res);
            if (res.data.status_code == 200) {
              that.$message.success("删除成功");
              that.getData();
            }
          });
        })
        .catch(() => {});
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.getData();
    },
    handleDiagnosisLook(row) {
      this.select_user_id = row.id;
      this.diagnosis_type = "";
      this.diagnosis_keyword = "";
      this.windowCurrentPage = 1;
      this.diagnosisLookVisible = true;
      this.getDiagnosisData();
    },
    handleDiagnosisSelect() {
      this.windowCurrentPage = 1;
      this.getDiagnosisData();
    },
    handleDiagnosisSearch() {
      this.windowCurrentPage = 1;
      this.getDiagnosisData();
    },
    handleDiagnosisPageChange(val) {
      this.windowCurrentPage = val;
      this.getDiagnosisData();
    },
    handleDiagnosisDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http2
            .delete(
              "/admin/users/" + that.select_user_id + "/diagnosis/" + row.id
            )
            .then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("删除成功");
                that.getDiagnosisData();
              }
            });
        })
        .catch(() => {});
    },
    handleDiagnosisSelectionChange(val) {
      this.diagnosismultipleSelection = val;
    },
    delDiagnosisAllSelection() {
      let that = this;
      const length = that.diagnosismultipleSelection.length;
      if (length > 0) {
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            let str = "";
            for (let i = 0; i < length; i++) {
              if (i > 0) {
                str += "," + that.diagnosismultipleSelection[i].id;
              } else {
                str += that.diagnosismultipleSelection[i].id;
              }
            }
            http2
              .delete(
                "/admin/users/" + that.select_user_id + "/diagnosis/" + str
              )
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success("删除成功");
                  that.diagnosismultipleSelection = [];
                  that.getDiagnosisData();
                }
              });
          })
          .catch(() => {});
      } else {
        that.$message.warning("请最少选择一项");
      }
    },
    handleAddressLook(row) {
      this.select_user_id = row.id;
      this.windowCurrentPage = 1;
      this.addressLookVisible = true;
      this.getAddressData();
    },
    handleAddressSelectionChange(val) {
      this.addressmultipleSelection = val;
    },
    delAddressAllSelection() {
      let that = this;
      const length = that.addressmultipleSelection.length;
      if (length > 0) {
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            let str = "";
            for (let i = 0; i < length; i++) {
              if (i > 0) {
                str += "," + that.addressmultipleSelection[i].address_id;
              } else {
                str += that.addressmultipleSelection[i].address_id;
              }
            }
            let params = { address_ids: str };
            http
              .delete("/admin/user/" + that.select_user_id + "/addresses", {
                params: params,
              })
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success("删除成功");
                  that.addressmultipleSelection = [];
                  that.getAddressData();
                }
              });
          })
          .catch(() => {});
      } else {
        that.$message.warning("请最少选择一项");
      }
    },
    handleAddressDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          let params = { address_ids: row.address_id };
          http
            .delete("/admin/user/" + that.select_user_id + "/addresses", {
              params: params,
            })
            .then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("删除成功");
                that.getAddressData();
              }
            });
        })
        .catch(() => {});
    },
    addAddressEdit(add, row) {
      this.is_add = add;
      if (add) {
        this.address_form = {
          nickname: "",
          phone: "",
          province: "",
          city: "",
          street: "",
          address: "",
          tag_name: "",
        };
      } else {
        this.address_form = row;
        let area = JSON.parse(row.area);
        this.address_form = {
          address_id: row.address_id,
          nickname: row.nickname,
          phone: row.phone,
          province: area[0]["id"],
          city: area[1]["id"],
          street: area[2]["id"],
          address: row.address,
          tag_name: row.tag_name,
        };

        let that = this;
        http3.get("/areas/" + that.address_form.province).then(function (res) {
          that.citys = res.data.data;
        });
        http3.get("/areas/" + that.address_form.city).then(function (res) {
          that.streets = res.data.data;
        });
        if (area[1]["name"] == "市辖区") {
          this.city_show = false;
        }
      }
      this.addressEditVisible = true;
    },
    handleAddressPageChange(val) {
      this.windowCurrentPage = val;
      this.getAddressData();
    },
    handleProvinceSelect() {
      let that = this;
      that.address_form.city = "";
      that.address_form.street = "";
      http3.get("/areas/" + that.address_form.province).then(function (res) {
        that.streets = [];
        that.citys = res.data.data;
        if (that.citys[0]["name"] == "市辖区") {
          that.city_show = false;
          that.address_form.city = that.citys[0]["id"];
          http3.get("/areas/" + that.address_form.city).then(function (res) {
            that.streets = res.data.data;
          });
        } else {
          that.city_show = true;
        }
      });
    },
    handleCitySelect() {
      let that = this;
      that.address_form.street = "";
      http3.get("/areas/" + that.address_form.city).then(function (res) {
        that.streets = res.data.data;
      });
    },
    saveAddresssEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let area = [];
          let province_obj = _.filter(that.provinces, function (selector) {
            return selector.id === that.address_form.province;
          })[0];
          let city_obj = _.filter(that.citys, function (selector) {
            return selector.id === that.address_form.city;
          })[0];
          let street_obj = _.filter(that.streets, function (selector) {
            return selector.id === that.address_form.street;
          })[0];
          area.push(province_obj);
          area.push(city_obj);
          area.push(street_obj);
          let params = {
            nickname: that.address_form.nickname,
            phone: that.address_form.phone,
            area: JSON.stringify(area),
            address: that.address_form.address,
            tag_name: that.address_form.tag_name,
          };
          if (that.is_add) {
            http
              .post("/admin/user/" + that.select_user_id + "/addresses", params)
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success(`新增成功`);
                  that.getAddressData();
                }
              });
          } else {
            http
              .put(
                "/admin/user/" +
                  that.select_user_id +
                  "/addresses/" +
                  that.address_form.address_id,
                params
              )
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success(`修改成功`);
                  that.getAddressData();
                }
              });
          }
          that.addressEditVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleArchivesLook(row) {
      this.select_user_id = row.id;
      this.archives_keywords = "";
      this.windowCurrentPage = 1;
      this.archivesLookVisible = true;
      this.getArchivesData();
    },
    handleArchivesSearch() {
      this.windowCurrentPage = 1;
      this.getArchivesData();
    },
    handleArchivesDelete(row) {
      let that = this;
      // 二次确认删除
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http2
            .delete(
              "/admin/users/" + that.select_user_id + "/archives/" + row.id
            )
            .then(function (res) {
              // console.log(res);
              if (res.data.status_code == 200) {
                that.$message.success("删除成功");
                that.getArchivesData();
              }
            });
        })
        .catch(() => {});
    },
    handleArchivesSelectionChange(val) {
      this.archivesmultipleSelection = val;
    },
    delArchivesAllSelection() {
      let that = this;
      const length = that.archivesmultipleSelection.length;
      if (length > 0) {
        that
          .$confirm("确定要删除吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            let str = "";
            for (let i = 0; i < length; i++) {
              if (i > 0) {
                str += "," + that.archivesmultipleSelection[i].id;
              } else {
                str += that.archivesmultipleSelection[i].id;
              }
            }
            http2
              .delete(
                "/admin/users/" + that.select_user_id + "/archives/" + str
              )
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success("删除成功");
                  that.archivesmultipleSelection = [];
                  that.getArchivesData();
                }
              });
          })
          .catch(() => {});
      } else {
        that.$message.warning("请最少选择一项");
      }
    },
    addArchivesEdit(add, row) {
      let that = this;
      that.is_add = add;
      if (add) {
        that.archives_form = {
          name: "",
          phone: "",
          sex: 1,
          birthday: "",
          relationship_id: 1,
          weight: "",
          height: "",
          anamnesis: "",
          allergic_history: "",
        };
        that.archivesEditVisible = true;
      } else {
        http2
          .get("/admin/users/" + that.select_user_id + "/archives/" + row.id)
          .then(function (res) {
            if (res.data.status_code == 200) {
              let archives_data = res.data.data;
              that.archives_form = {
                id: archives_data.id,
                name: archives_data.name,
                phone: archives_data.phone,
                sex: archives_data.sex,
                birthday: that.formatDate(archives_data.birthday),
                relationship_id: archives_data.relationship_id,
                weight: archives_data.weight,
                height: archives_data.height,
                anamnesis: archives_data.anamnesis,
                allergic_history: archives_data.allergic_history,
              };
              that.archivesEditVisible = true;
            }
          });
      }
    },
    lookArchivesDetail(row) {
      let that = this;
      http2
        .get("/admin/users/" + that.select_user_id + "/archives/" + row.id)
        .then(function (res) {
          if (res.data.status_code == 200) {
            let archives_data = res.data.data;
            console.log(archives_data.relationship_id);
            that.archives_detail = {
              name: archives_data.name,
              phone: archives_data.phone,
              sex: that.getSexType(archives_data.sex),
              birthday: new Date(archives_data.birthday * 1000).Format(
                "YYYY-MM-DD"
              ),
              relationship_title: that.getRelationshipTitle(
                archives_data.relationship_id
              ),
              weight: archives_data.weight,
              height: archives_data.height,
              anamnesis: archives_data.anamnesis,
              allergic_history: archives_data.allergic_history,
            };
            that.archivesDetailVisible = true;
          }
        });
    },
    closeArchivesDetail() {
      this.archivesDetailVisible = false;
    },
    saveArchivesEdit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let birthday_date = new Date(that.archives_form.birthday);
          let params = {
            name: that.archives_form.name,
            birthday: birthday_date.getTime() / 1000,
            sex: that.archives_form.sex,
            phone: that.archives_form.phone,
            relationship_id: that.archives_form.relationship_id,
            weight: that.archives_form.weight,
            height: that.archives_form.height,
            anamnesis: that.archives_form.anamnesis,
            allergic_history: that.archives_form.allergic_history,
          };
          if (that.is_add) {
            http2
              .post("/admin/users/" + that.select_user_id + "/archives", params)
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success(`新增成功`);
                  that.getArchivesData();
                }
              });
          } else {
            http2
              .put(
                "/admin/users/" +
                  that.select_user_id +
                  "/archives/" +
                  that.archives_form.id,
                params
              )
              .then(function (res) {
                if (res.data.status_code == 200) {
                  that.$message.success(`修改成功`);
                  that.getArchivesData();
                }
              });
          }
          that.archivesEditVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
.table {
  width: 100%;
  font-size: 14px;
}
.red {
  color: #ff0000;
}
.mr10 {
  margin-right: 10px;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}
.self-dialog-footer {
  display: block;
  text-align: center;
}
</style>
